import React, { useState } from 'react';
import { ArrowLeft, CreditCard, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
interface FlightCheckoutScreenProps {
  onBack: () => void;
  onConfirm: () => void;
}
export function FlightCheckoutScreen({
  onBack,
  onConfirm
}: FlightCheckoutScreenProps) {
  const [isProcessing, setIsProcessing] = useState(false);
  const handlePay = () => {
    setIsProcessing(true);
    setTimeout(() => {
      setIsProcessing(false);
      onConfirm();
    }, 2000);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-206">
      <header className="bg-[#003366] px-6 pt-12 pb-6 sticky top-0 z-10 flex items-center gap-4" data-id="element-207">
        <button onClick={onBack} className="p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-208">
          <ArrowLeft size={24} className="text-white" data-id="element-209" />
        </button>
        <h1 className="text-xl font-bold text-white" data-id="element-210">
          Confirmer la réservation
        </h1>
      </header>

      <div className="flex-1 px-6 py-6 space-y-6" data-id="element-211">
        {/* Summary */}
        <Card data-id="element-212">
          <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4" data-id="element-213">
            Résumé du vol
          </h3>
          <div className="flex justify-between items-start mb-4" data-id="element-214">
            <div data-id="element-215">
              <div className="text-2xl font-bold text-[#003366]" data-id="element-216">DSS</div>
              <div className="text-xs text-gray-500" data-id="element-217">Dakar</div>
            </div>
            <div className="flex flex-col items-center pt-2" data-id="element-218">
              <span className="text-xs text-gray-400" data-id="element-219">7h 30m</span>
              <div className="w-16 h-[1px] bg-gray-300 my-1" data-id="element-220"></div>
              <span className="text-xs text-[#D4A017] font-medium" data-id="element-221">Direct</span>
            </div>
            <div className="text-right" data-id="element-222">
              <div className="text-2xl font-bold text-[#003366]" data-id="element-223">DXB</div>
              <div className="text-xs text-gray-500" data-id="element-224">Dubaï</div>
            </div>
          </div>
          <div className="bg-gray-50 p-3 rounded-lg text-sm text-gray-700 flex justify-between" data-id="element-225">
            <span data-id="element-226">Passager</span>
            <span className="font-medium" data-id="element-227">Amadou Diallo</span>
          </div>
        </Card>

        {/* Price Breakdown */}
        <Card data-id="element-228">
          <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4" data-id="element-229">
            Détails du paiement
          </h3>
          <div className="space-y-3 text-sm" data-id="element-230">
            <div className="flex justify-between text-gray-600" data-id="element-231">
              <span data-id="element-232">Tarif de base (1 Adulte)</span>
              <span data-id="element-233">470 000 FCFA</span>
            </div>
            <div className="flex justify-between text-gray-600" data-id="element-234">
              <span data-id="element-235">Taxes & Frais</span>
              <span data-id="element-236">15 000 FCFA</span>
            </div>
            <div className="pt-3 border-t border-gray-100 flex justify-between text-lg font-bold text-[#003366]" data-id="element-237">
              <span data-id="element-238">Total</span>
              <span data-id="element-239">485 000 FCFA</span>
            </div>
          </div>
        </Card>

        {/* Payment Method */}
        <div className="bg-white p-4 rounded-2xl border border-gray-200" data-id="element-240">
          <div className="flex items-center gap-3 mb-3" data-id="element-241">
            <div className="p-2 bg-[#003366] text-white rounded-lg" data-id="element-242">
              <CreditCard size={20} data-id="element-243" />
            </div>
            <div className="flex-1" data-id="element-244">
              <div className="font-medium text-gray-900" data-id="element-245">ALAL Visa</div>
              <div className="text-xs text-gray-500" data-id="element-246">Solde : 450 000 FCFA</div>
            </div>
          </div>

          {/* Insufficient Funds Warning */}
          <div className="bg-red-50 p-3 rounded-xl flex gap-3 items-start" data-id="element-247">
            <AlertCircle size={16} className="text-red-600 mt-0.5" data-id="element-248" />
            <div data-id="element-249">
              <p className="text-sm font-medium text-red-700" data-id="element-250">
                Solde insuffisant
              </p>
              <p className="text-xs text-red-600 mt-0.5" data-id="element-251">
                Il vous manque 35 000 FCFA.
              </p>
              <button className="text-xs font-bold text-red-700 underline mt-1" data-id="element-252">
                Recharger maintenant
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="p-6 bg-white border-t border-gray-100 mt-auto" data-id="element-253">
        <div className="text-center text-xs text-gray-500 mb-4" data-id="element-254">
          Aucun frais caché. Vous payez exactement ce que vous voyez.
        </div>
        <Button fullWidth size="lg" onClick={handlePay} isLoading={isProcessing} disabled={false} data-id="element-255">
          Payer 485 000 FCFA
        </Button>
      </div>
    </div>;
}